import React from 'react';
import BlogList from '../components/BlogList';
import { Layout } from '../Layout';

const Blog: React.FC = () => (
    <Layout>
        <BlogList />
    </Layout>
);

export default Blog;
